import components from "./icons";

export default {
  name: "svg-icon",
  components,
  props: {
    iconName: {
      type: String,
      default: "box"
    },
    size: {
      type: [Number, String],
      default: 18
    },
    width: {
      type: [Number, String],
      default: "auto"
    },
    height: {
      type: [Number, String],
      default: "auto"
    },
    iconColor: {
      type: String,
      default: "currentColor"
    },
    iconTitle: {
      type: String,
      default: ""
    },
    box: {
      type: String,
      default: "0 0 18 18"
    }
  },

  computed: {
    svgAttributes() {
      return {
        width: this.size && this.width == "auto" ? this.size : this.width,
        height: this.size && this.height == "auto" ? this.size : this.height
      };
    }
  },

  render(h) {
    const title =
      this.iconTitle && this.iconTitle.length
        ? h(
            "title",
            {
              domProps: {
                lang: "en"
              }
            },
            this.iconTitle
          )
        : null;

    const icon = h(this.iconName);

    const group = h(
      "g",
      {
        attrs: {
          fill: this.iconColor,
          lang: "ru"
        },
        domProps: {
          id: this.iconName
        }
      },
      [icon]
    );

    return h(
      "svg",
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: this.box,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          ...this.svgAttributes
        }
      },
      [title, group]
    );
  }
};
